import { KYMW00Model } from './../../../../commons/kymw00/kymw00.model';

export class KYMW1310PlanMultiPublishModel {
  // 受注コード
  public orderCode: string = <string>'';
  // Pコード
  public pCode: string = <string>'';
  // 多重掲載設定一覧
  public multiPublishList: Array<any> = null;
}
